var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLniFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5842 2.91089C11.2277 2.52475 10.7525 2.28713 10.2178 2.28713H1.36634V0.683168C1.36634 0.326733 1.06931 0 0.683168 0C0.29703 0 0 0.29703 0 0.683168V17.3168C0 17.6733 0.29703 18 0.683168 18C1.06931 18 1.36634 17.703 1.36634 17.3168V10.4257H9.59406C10.5149 10.4257 11.2871 9.74257 11.4059 8.85149L12 4.33663C12.0594 3.80198 11.9109 3.29703 11.5842 2.91089ZM10.099 8.67327C10.0693 8.91089 9.86139 9.08911 9.62376 9.08911H1.36634V3.62376H10.1881C10.3663 3.62376 10.4851 3.71287 10.5446 3.77228C10.604 3.83168 10.6931 3.9505 10.6634 4.15842L10.099 8.67327Z",
    fill: "#996B68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLniFlag);
export default __webpack_public_path__ + "static/media/lni_flag.6276d5f05faf10ee5972222db1d273ea.svg";
export { ForwardRef as ReactComponent };